import { BDCPFilterModule } from '../filter/filter.module';
import { BDCPProductFinderResultsComponent } from './pages/results/results.page';
import { BDCPProductFinderRootComponent } from './pages/root/root.page';
import { BDCPSharedModule } from '../shared/shared.module';
import { BDSharedModule } from '@brother-apps/brother-dealerapp-shared-lib';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import {BDCPProductsSearchBarComponent} from './components/products-search-bar/products-search-bar.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule,
        BDCPSharedModule,
        BDCPFilterModule,
        BDSharedModule
    ],
    declarations: [
        // Pages
        BDCPProductFinderRootComponent,
        BDCPProductFinderResultsComponent,
        BDCPProductsSearchBarComponent,
    ],
    exports: [
        // Pages
        BDCPProductFinderRootComponent,
        BDCPProductFinderResultsComponent,
        BDCPProductsSearchBarComponent,
    ],
    providers: [

    ]
})
export class BDCPProductFinderModule { }
